module.exports = __webpack_public_path__ + "img/dailymeal.03c0d45a.png";